import React, { useEffect, useState } from "react";
import ContactPopup from "../../components/ContactPopup";
import { InsightsSection } from "../../components/common";
import { TestimonialSection } from "../../components/home";
import { ReadyToElevateSection } from "../../components/team-building";
import {
  InstitutionHeroSection,
  PartnershipProcessSection,
  PartnershipsSection,
  ProgramsSection,
  WhyCatalyzeSection,
} from "../../components/institution";
import institutionData from "../../data/institutionData.json";
import "./institution.css";

export default function Institution({ initialData }) {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="institution-page">
      <InstitutionHeroSection data={institutionData.hero} />
      <PartnershipProcessSection data={institutionData.gapProcess} />
      <WhyCatalyzeSection
        data={institutionData.whyCatalyze}
        onBookSession={() => setIsPopupOpen(true)}
      />
      <PartnershipProcessSection
        data={institutionData.partnershipProcess}
        onStartConversation={() => setIsPopupOpen(true)}
      />
      <ProgramsSection data={institutionData.programs} />
      <PartnershipsSection
        data={institutionData.partnerships}
        onPartner={() => setIsPopupOpen(true)}
      />
      <TestimonialSection testimonials={institutionData.testimonials} />
      <ReadyToElevateSection
        data={institutionData.readyToElevate}
        onAction={() => setIsPopupOpen(true)}
      />
      <InsightsSection  initialData={initialData} />
      
      <ContactPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
}
